export const en = {
    'add-additions-item-callouts': 'Add callouts',
    'add-banners-display-hrefs': 'Add display links',
    'add-creatives': 'Add creatives for display ads',
    'add-image-to-banner': 'Add images',
    'add-more-pictures-to-adgroup': 'Add images',
    'add-outdoor-creatives': 'Upload creatives for outdoor ads',
    'add-placements': 'Add billboards',
    'add-site-links': 'Add sitelinks',
    'add-title-extension': 'Add second title',
    'add-turbo-web-site-to-banner': 'Add Turbo page',
    'all-platforms': 'On all ad platforms',
    archived: 'Archived',
    'autobudget-priority': 'Priority',
    avgClickCost: 'Average CPC',
    avgCpmCost: 'Average CPM',
    avgGoalCost: 'CPA',
    'banner-body': 'Ad text',
    'banner-status-active': 'Active',
    'banner-status-archived': 'Archived',
    'banner-status-draft': 'Draft',
    'banner-status-manually-suspended': 'Suspended',
    'banner-status-moderation': 'Under moderation',
    'banner-status-moderation-rejected': 'Rejected by moderation',
    'banner-status-temporarly-suspended': 'Temporarily paused',
    'banner-title': 'Title',
    'banner-title-extension': 'Ad title extension',
    'banner-type': 'Ad type',
    'banner-type-cpm_metro': 'Banner in Yandex Metro',
    'bid-modifiers': 'Bid adjustments',
    'bounce-rate': 'Bounce rate',
    broadmatch: 'Related keywords',
    budgetLimit: 'Budget limit',
    'campaign-type': 'Campaign type',
    'change-adgroup-for-moderation': 'Submit for moderation',
    'change-adgroup-with-low-stat': 'Fix groups with Rarely served status',
    'change-banner-for-moderation': 'Submit for moderation',
    clicks: 'Clicks',
    context: 'In ad networks',
    'context-price': 'Bid (in ad networks)',
    'converison-rate': '% of conversion',
    cost: 'Expenditure',
    cpa: 'CPA',
    cpc: 'CPC',
    cpm: 'CPM',
    ctr: 'CTR',
    'daily-budget': 'Raise the budget limit',
    'deal-id': 'Deal ID',
    'deal-type': 'Deal type',
    disabled: 'Disabled',
    draft: 'Draft',
    enabled: 'Enabled',
    'finish-date': 'End date',
    goals: 'Conversions',
    'group-status-active': 'Active',
    'group-status-archived': 'Archived',
    'group-status-draft': 'Draft',
    'group-status-moderation': 'Under moderation',
    'group-status-rejected': 'Rejected during moderation',
    'group-status-stopped': 'Stopped',
    'has-image': 'Image',
    'has-sitelinks': 'Sitelinks',
    'has-turbolanding': 'Turbo pages',
    id: 'ID',
    keyword: 'Keywords',
    libraryMinusPhrasePacks: 'Sets of negative keywords',
    metrics: 'Statistics',
    metrika: 'Metrica tag',
    'min-price': 'Min. CPM',
    'minus-phrase-packs': 'Sets of negative keywords',
    'moderation-denied': 'Rejected during moderation',
    'moderation-pending': 'Under moderation',
    'money-finished': 'Insufficient funds',
    name: 'Name',
    'name-minus-phrase-packs': 'Name of a set of negative keywords',
    number: 'Number',
    numberOfLinkedCampaigns: 'Number of linked campaigns',
    'phrase-status-active': 'Active',
    'phrase-status-archived': 'Archived',
    'phrase-status-draft': 'Draft',
    'phrase-status-moderation-rejected': 'Rejected during moderation',
    'phrase-status-suspended': 'Stopped',
    platform: 'Platform',
    price: 'Maximum CPC',
    'price-context': 'Maximum CPC (in ad networks)',
    'price-context-cpm': 'Bid per 1000 impressions',
    profitability: 'ROI',
    recommendations: 'Recommendations',
    'remove-page-from-blacklist': 'Enable quality ad platforms',
    revenue: 'Revenue',
    search: 'On search',
    'send-licenses': 'Send documents',
    'send-licenses-banks': 'Send documents for Banking services',
    'send-licenses-med-services': 'Send documents for Medical services',
    'send-licenses-pharmacy': 'Send documents for Pharmacies and Medicine',
    settings: 'Settings',
    shows: 'Impressions',
    'site-monitoring': 'Site monitoring',
    spent: 'Spending',
    'start-date': 'Start date',
    started: 'Started',
    'statistics-by-all-goals': 'For all goals',
    status: 'Status',
    stopped: 'Stopped',
    strategy: 'Strategy',
    'switch-on-autotargeting': 'Enable autotargeting',
    'target-funnel': 'Target audience',
    'temporarily-paused': 'Temporarily paused'
};
